export default __webpack_public_path__ + "static/media/india.e900a0db.svg";